// サーバサイドでのデータ管理による通信の可否判断

const Konashi = require('../konashijs/konashi5.js');

class _PioPin {
    constructor (pin) {
        // 何番PINか
        this.number = pin;
        // config (DISABLE|ENABLE|PWM(2)|I2C(3)|SPI(4), (NOTIFY + INPUT|OUTPUT), NO_PULL|PULL_UP|PULL_DOWN)
        this.config = [Konashi.consts.DISABLE, Konashi.consts.NOTIFY, Konashi.consts.NO_PULLS];
        // input,output (value)
        this.input = Konashi.consts.LOW; // 0
        this.output = Konashi.consts.LOW;
        // softPWM (DISABLE|DUTY|PERIOD, set value, out value, trans)
        this.softPWM = [[Konashi.consts.DISABLE, 0], 0, 0];
        // hardPWM (DISABLE|ENABLE, out value, trans)
        this.hardPWM = [Konashi.consts.DISABLE, 0, 0];
    }

}

class _AioPin {
    constructor (pin) {
        // 何番PINか
        this.number = pin;
        // config DISABLE|ENABLE + (NOTIFY + INPUT|OUTPUT)
        this.config = 0;//
        // input,output (ref,value(,trans))
        this.input = [Konashi.consts.DISABLE, 0];
        this.output = [Konashi.consts.DISABLE, 0, 0];
    }
}

const BLE_DELAY = {
    NORMAL: 100,
    LONG: 200
};

class KokoroPro {
    constructor () {
        this._konashi = null;
        this._name = null;
        this._isConnectionFailed = false;
        this.conDone = false;
        
        this._isSending = 0; // 現在送信QueueにたまっているPromiseの数
        this.notified = true; // Boolean

        this.clkConfig = [null, null]; // HardPWMのclockConfig内容

        this.anaConfig = [0, 0, 0, 0]; // Analog config内容

        this.i2c = [Konashi.consts.DISABLE, Konashi.consts.DISABLE]; // i2c config内容
        this.uart = [null, null, null, null]; // uart config内容
        this.uartData = '';
        this.spiConf = [null, null, null, null]; // spi config内容
        this.spiData = '';

        this._pioPins = [
            new _PioPin(0),
            new _PioPin(1),
            new _PioPin(2),
            new _PioPin(3),
            new _PioPin(4),
            new _PioPin(5),
            new _PioPin(6),
            new _PioPin(7)
        ];

        this._aioPins = [
            new _AioPin(0),
            new _AioPin(1),
            new _AioPin(2)
        ];

        this._buildIn = [0, 0, 0]; // temp,humi,bool
        this._ag = [0, 0, 0, 0, 0, 0]; // ax,ay,az,gx,gy,gz
        this._colors = [0, 0, 0, 0, 0]; // red,blue,green,alpha,trans

        const that = this;
        /**
         * @param {number[]} v except i2c, uart & spi data
         * @param {number} type notification data type
         */
        this._onNotified = ((v, type) => {
            that._pioPins.forEach(pin => {
                if (type == 0){ // Digital Config
                    if (v[pin.number][0] != 0){ // GPIO,AIO
                        if (that._pioPins[pin.number].config[0] != v[pin.number][0]){
                            that._pioPins[pin.number].config[0] = v[pin.number][0];
                            that.notified = true;
                            console.log(`mode${pin.number}${that._pioPins[pin.number].config[0]}`);
                        }
                        if (that._pioPins[pin.number].config[1] != v[pin.number][1]){
                            that._pioPins[pin.number].config[1] = v[pin.number][1];
                            that.notified = true;
                            console.log(`config${pin.number}${that._pioPins[pin.number].config[1]}`);
                        } else if (that._pioPins[pin.number].config[2] != v[pin.number][2]){
                            that._pioPins[pin.number].config[2] = v[pin.number][2];
                            that.notified = true;
                            console.log(`pull${pin.number}${that._pioPins[pin.number].config[2]}`);
                        }
                    }
                }
                if (type == 1){ // Digital IO
                    if (v[pin.number][0] != 0){
                        if (that._pioPins[pin.number].config[1] == Konashi.consts.INPUT + Konashi.consts.NOTIFY){
                            if (that._pioPins[pin.number].input != v[pin.number][1]){
                                that._pioPins[pin.number].input = v[pin.number][1];
                                // Konashi.consts.HIGH || Konashi.consts.LOW
                                console.log(`input${pin.number}${that._pioPins[pin.number].input}`);
                            }
                        } else if (that._pioPins[pin.number].config[1] ==
                            Konashi.consts.OUTPUT + Konashi.consts.NOTIFY){
                            if (that._pioPins[pin.number].output != v[pin.number][1]){
                                that._pioPins[pin.number].output = v[pin.number][1];
                                // Konashi.consts.HIGH || Konashi.consts.LOW
                                that.notified = true;
                                console.log(`output${pin.number}${that._pioPins[pin.number].output}`);
                            }
                        }
                    }
                }
                if (pin.number < 4){ // PWM,AG
                    if (type == 2){
                        if (v[pin.number][0] != 0){
                            if (JSON.stringify(that._pioPins[pin.number].softPWM[0]) != JSON.stringify(v[pin.number])){
                                that._pioPins[pin.number].softPWM[0] = v[pin.number];
                                that.notified = true;
                                console.log(`softPWM config${pin.number}${that._pioPins[pin.number].softPWM[0][1]}`);
                            }
                        }
                    }
                    if (type == 3){
                        if (v[pin.number] != 0) {
                            if (that._pioPins[pin.number].softPWM[1] != v[pin.number][1]){
                                that._pioPins[pin.number].softPWM[1] = v[pin.number][1];
                                that.notified = true;
                                console.log(`softPWM${pin.number}${that._pioPins[pin.number].softPWM[1]}`);
                            }
                            if (that._pioPins[pin.number].softPWM[2] != v[pin.number][2]){
                                that._pioPins[pin.number].softPWM[2] = v[pin.number][2];
                                console.log(`soft trans${that._pioPins[pin.number].softPWM[2]}`);
                            }
                        }
                    }
                    if (type == 4){
                        if (that._pioPins[pin.number].hardPWM[0] != v[pin.number]){
                            that._pioPins[pin.number].hardPWM[0] = v[pin.number];
                            that.notified = true;
                            console.log(`hardPwmOn${pin.number}${that._pioPins[pin.number].hardPWM[0]}`);
                        }
                    }
                    if (type == 5){
                        if (that._pioPins[pin.number].hardPWM[1] != v[pin.number][0]){
                            that._pioPins[pin.number].hardPWM[1] = v[pin.number][0];
                            that.notified = true;
                            console.log(`hardPWM${pin.number}${that._pioPins[pin.number].hardPWM[1]}`);
                        }
                        if (that._pioPins[pin.number].hardPWM[2] != v[pin.number][1]){
                            that._pioPins[pin.number].hardPWM[2] = v[pin.number][1];
                            console.log(`hardPWM trans${pin.number}${that._pioPins[pin.number].hardPWM[2]}`);
                        }
                    }
                }
                if (pin.number < 3){ // Analog,AG
                    if (type == 6){ // Analog Config
                        if (v[pin.number][0] != 0){
                            if (that._aioPins[pin.number].config != v[pin.number][1]){
                                that._aioPins[pin.number].config = v[pin.number][1];
                                // Konashi.consts.NOTIFY + (Konashi.consts.OUTPUT || Konashi.consts.INPUT)
                                that.notified = true;
                                console.log(`Analog config${pin.number}${that._aioPins[pin.number].config}`);
                            }
                        }
                    }
                    if (type == 7){ // Analog IO
                        if (v[pin.number][0] != 0){
                            if (that._aioPins[pin.number].config == Konashi.consts.INPUT + Konashi.consts.NOTIFY){
                                if (that._aioPins[pin.number].input[0] != v[pin.number][1]){
                                    that._aioPins[pin.number].input[0] = v[pin.number][1];
                                    console.log(`Analog In: ${that._aioPins[pin.number].input[0]}`);
                                }
                                if (that._aioPins[pin.number].input[1] != v[3]){
                                    that._aioPins[pin.number].input[1] = v[3];
                                    console.log(`In Ref${pin.number}${that._aioPins[pin.number].input[1]}`);
                                }
                            }
                            if (that._aioPins[pin.number].config == Konashi.consts.OUTPUT + Konashi.consts.NOTIFY){
                                if (that._aioPins[pin.number].output[0] != v[pin.number][1]){
                                    that._aioPins[pin.number].output[0] = v[pin.number][1];
                                    that.notified = true;
                                    console.log(`Analog Out: ${that._aioPins[pin.number].output[0]}`);
                                }
                                if (that._aioPins[pin.number].output[1] != v[3]){
                                    that._aioPins[pin.number].output[1] = v[3];
                                    console.log(`Out Ref${pin.number}${that._aioPins[pin.number].output[1]}`);
                                }
                                if (that._aioPins[pin.number].output[2] != v[pin.number][2]){
                                    that._aioPins[pin.number].output[2] = v[pin.number][2];
                                    console.log(`Out trans${pin.number}${that._aioPins[pin.number].output[2]}`);
                                }
                            }
                        }
                    }
                    if (type == 19){ // AG
                        if (that._ag[pin.number] != parseInt(v[pin.number], 16) / 4096){
                            that._ag[pin.number] = parseInt(v[pin.number], 16) / 4096;
                        }
                        if (that._ag[pin.number + 3] != parseInt(v[pin.number + 3], 16) / 32.8){
                            that._ag[pin.number + 3] = parseInt(v[pin.number + 3], 16) / 32.8;
                        }
                    }
                }
            });
            if (type == 4){ // hard PWM Config
                if (that.clkConfig[0] != v[4] || that.clkConfig[1] != v[5]){
                    that.clkConfig[0] = v[4];
                    that.clkConfig[1] = v[5];
                    that.notified = true;
                    console.log(`clock,presc:${that.clkConfig[0]} pwm timer:${that.clkConfig[1]}`);
                }
            }
            if (type == 6){ // Analog Config
                if (that.anaConfig[0] != v[3]){
                    that.anaConfig[0] = v[3];
                    that.notified = true;
                    console.log(`ADC period:${that.anaConfig[0]}`);
                }
                if (that.anaConfig[1] != v[4]){
                    that.anaConfig[1] = v[4];
                    that.notified = true;
                    console.log(`ADC ref:${that.anaConfig[1]}`);
                }
                if (that.anaConfig[2] != v[5]){
                    that.anaConfig[2] = v[5];
                    that.notified = true;
                    console.log(`VDAC ref:${that.anaConfig[2]}`);
                }
                if (that.anaConfig[3] != v[6]){
                    that.anaConfig[3] = v[6];
                    that.notified = true;
                    console.log(`IDAC ref:${that.anaConfig[3]}`);
                }
            }
            if (type == 8){ // I2C Config
                if (that.i2c[0] != v){
                    that.i2c[0] = v;
                    that.notified = true;
                    console.log(`i2c config:${v}`);
                }
            }
            if (type == 9){ // I2C Read
                that.i2c[1] = v[0];
                if (that.i2c[1] != 0){
                    console.log(`Error: error type ${that.i2c[1]}`);
                }
                that.notified = true;

                if (that.i2c[2] != v[1]){
                    that.i2c[2] = v[1];
                }
                if (v[2] != '' && that.i2c[3] != v[2]){
                    that.i2c[3] = v[2];
                    console.log(`I2C read value: ${that.i2c[3]}`);
                }
            }
            if (type == 10 && v[0] == 1){ // UART
                if (JSON.stringify(that.uart) != JSON.stringify(v)){
                    that.uart[0] = v[1];
                    that.uart[1] = v[2];
                    that.uart[2] = v[3];
                    that.notified = true;
                    console.log(`baud:${that.uart[2]}parity:${that.uart[0]}stopbit:${that.uart[1]}`);
                }
            }
            if (type == 11){
                if (that.uartData != v){
                    that.uartData = v;
                    console.log(that.uartData);
                }
            }
            if (type == 12){
                if (that.uart[3] != v){
                    that.uart[3] = v;
                    that.notified = true;
                }
            }
            if (type == 13 && v[0] == 1){ // SPI Config
                if (JSON.stringify(that.spiConf) != JSON.stringify(v)){
                    that.spiConf = v;
                    that.notified = true;
                    console.log(`bit rate:${that.spiConf[3]}endian:${that.spiConf[0]}polarity:${that
                        .spiConf[1]}phase:${that.spiConf[2]}`);
                }
            }
            if (type == 14){ // SPI
                that.spiData = v;
                console.log(that.spiData);
                that.notified = true;
            }
            if (type == 15){ // Pres
                if (that._buildIn[0] != v / 10){
                    that._buildIn[0] = v / 10;
                }
            }
            if (type == 16){ // Temp
                if (that._buildIn[1] != v / 100){
                    that._buildIn[1] = v / 100;
                }
            }
            if (type == 17){ // Humi
                if (that._buildIn[2] != v / 100){
                    that._buildIn[2] = v / 100;
                }
            }
            if (type == 18){ // Bool
                if (that._buildIn[3] != Boolean(v)){
                    that._buildIn[3] = Boolean(v);
                }
            }
            if (type == 20){ // LED
                if (that._colors[0] != v[0] || that._colors[1] != v[1] ||
                    that._colors[2] != v[2] || that._colors[3] != v[3]){
                    for (let i = 0; i < 4; i++){
                        that._colors[i] = v[i];
                    }
                    that.notified = true;
                    console.log(`R:${that._colors[0]} G:${that._colors[1]} B:${that._colors[2]}A: ${that._colors[3]}`);
                }
                if (that._colors[4] != v[4]){
                    that._colors[4] = v[4];
                }
            }
        });

    }

    /**
     * 接続を開始する
     * konashi の find, connect をラップしていることに加えて、
     * 初期起動時のPIN mode 書き換えとnotification登録も同時に行っている。
     *
     * @return {Promise<void>} 接続と初期設定の完了で解決するPromise
     */
    connect () {
        if (this._konashi) this._konashi.disconnect();

        const that = this;
        return Konashi.funcs
            .find(true, () => {
                that._isConnectionFailed = true;
            })
            .then(k => {
                // 見つかったら、このクラスに実態GATTBluetoothDeviceを登録
                that._konashi = k;
                that._name = k.name();

                return that._konashi.readConf(); // 初期設定のための状態認識
            })
            .then(v => {
                const data = [];
                for (let i = 0; i < 8; i++){
                    data[i] = v.getUint8(i * 2);
                }
                return data;
            })
            .then(v => that._reset(v)) // 初期設定
            .then(() => that._konashi.startnotification()) // notificationスタート
            .then(() => that._addevent()) // イベント追加
            .then(() => {
                console.log('finish notification');
                that.conDone = true;
                that._isSending = 0;
            });
    }

    /**
     *
     * @returns {boolean} 接続状態
     */
    isConnected () {
        let connected = false;
        if (this._konashi) {
            connected = this._konashi.isConnected();
        }
        return connected;
    }

    isConnectionFailed () {
        return this._isConnectionFailed;
    }

    /**
     * wait completing pre-action(in wait), correct other Pim mode(in first then) & set digital pin mode(in setGpio)
     * @param {number} pin GPIO pin number (0-7)
     * @param {number} mode pin mode
     * @returns {Promise|string} Promise of the command result, or an error message string
     */
    setIO (pin, mode) {
        if (!this._konashi) return 'no file'; // konashiを読み込めているか確認
        if (pin < 0 || pin > 7) return 'unexpected pin number'; // gpioPinの範囲内

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (that._pioPins[pin].config[0] == Konashi.consts.ENABLE &&
                    that._pioPins[pin].config[1] == mode + Konashi.consts.NOTIFY) throw new Error('same');
                // 同じ状態にするコマンドは送らない
                    
                if (that._pioPins[pin].config[0] == 2){
                    if (pin < 4){
                        return that._konashi.setHardPwmPin(pin, Konashi.consts.DISABLE);
                    }
                    return that._konashi.setSoftPWM(pin - 4, Konashi.consts.DISABLE, 0);
                        
                } else if (that._pioPins[pin].config[0] == 3){
                    return that._konashi.setI2c(Konashi.consts.DISABLE, 0);
                } else if (that._pioPins[pin].config[0] == 4){
                    return that._konashi.setSpi(Konashi.consts.DISABLE, 0, 0, 0, 0);
                } return;
            })
            .then(() =>
                that._konashi.setGpio(pin, Konashi.consts.ENABLE, mode, that._pioPins[pin].config[2])// 送信
            )
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * set digital pin's pull mode(in setGpio)
     * @param {number} pin GPIO pin number (0-7)
     * @param {number} pull pull mode
     * @returns {Promise} Promise of the command result
     */
    setPull (pin, pull) {
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (pin < 0 || pin > 7) return; // gpioPinの範囲内

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (that._pioPins[pin].config[2] == pull) throw new Error('same'); // 同じ状態にするコマンドは送らない
                if (that._pioPins[pin].config[0] != Konashi.consts.ENABLE) throw new Error('mode: not digital');
                // Gpioか確認

                return that._konashi.setGpio(pin, Konashi.consts.ENABLE, that._pioPins[pin].config[1] - 2, pull);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * Confirm if the pin mode is Konashi.consts.OUTPUT before call this function.
     *
     * @param {Konashi.consts.PIOX} pin GPIO pin number (0-7)
     * @param {Konashi.consts.HIGI|LOW} value output value
     * @returns {Promise} Promise of the command result
     */
    writeGpio (pin, value) {
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (pin < 0 || pin > 7) return; // gpioPinの範囲内

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                if (that._pioPins[pin].config[0] !=
                    Konashi.consts.ENABLE) throw new Error('It\'s not digital pin mode');
                // Gpioか確認
                if (that._pioPins[pin].config[1] != Konashi.consts.OUTPUT + 2) throw new Error('mode:not output');
                // modeがOutput以外になっていないか確認
                if (that._pioPins[pin].digital != '2' && that._pioPins[pin].digital == value) throw new Error('same');
                // 同じコマンドではないか（トグルを除く）の確認
                this._pioPins[pin].digital = null;
                return that._konashi.digitalWrite(pin, value); // 送信
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    readGpio (pin, io) {
        if (pin < 0 || pin > 7) return 'unexpected pin number'; // gpioPinの範囲内

        if (io == Konashi.consts.INPUT) return this._pioPins[pin].input;
        if (io == Konashi.consts.OUTPUT) return this._pioPins[pin].output;
        return;
    }

    setSoftPWM (pin, ctrlt, value){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(value)) return 'Not a Number';
        if (value < 0) value = 0;
        if (ctrlt == 1){
            if (value > 65535) value = 65535;
        } else if (value > 1000) value = 1000;

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (ctrlt == Konashi.consts.PERIOD)value = value * 10;
                if (ctrlt == that._pioPins[pin].softPWM[0][0] &&
                    value == that._pioPins[pin].softPWM[0][0]) throw new Error('same');
                // 同じ状態にするコマンドは送らない
                that.notified = false;

                if (that._pioPins[pin + 4].config[0] == Konashi.consts.ENABLE){
                    return that._konashi.setGpio(pin + 4, Konashi.consts.DISABLE, 0, 0);
                } else if (that._pioPins[pin].config[0] == 3){
                    return that._konashi.setI2c(Konashi.consts.DISABLE, 0);
                } else if (that._pioPins[pin].config[0] == 4){
                    return that._konashi.setSpi(Konashi.consts.DISABLE, 0, 0, 0, 0);
                } return;
            })
            .then(() => {
                that._pioPins[pin].softPWM[0] = [Konashi.consts.DISABLE, 0];
                return that._konashi.setSoftPWM(pin, ctrlt, value);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    outSoftPWM (pin, value, trans){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(value) || isNaN(trans)) return 'Not a Number';
        if (value < 0) value = 0;
        if (trans < 0) trans = 0;
        if (trans > 4294967295) trans = 4294967295;

        const that = this;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                that.notified = false;
                if (that._pioPins[pin + 4].config[0] != 2) throw new Error('It\'s not softPWM pin mode');
                if (that._pioPins[pin].softPWM[0][0] == 1){
                    if (value > 1000) value = 1000;
                } else if (value > 65535) value = 65535;
                if (that._pioPins[pin].softPWM[1] == value) throw new Error('Same');

                that._pioPins[pin].softPWM[1] = -1;
                return that._konashi.outSoftPWM(pin, value, trans);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    readSoftPWM (pin, type){
        if (pin < 0 || pin > 3) return 'unexpected pin number'; // gpioPinの範囲内

        return this._pioPins[pin].softPWM[type + 1];
    }

    setHardPwmPin (pin){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (parseInt(pin, 10) < 0 && parseInt(pin, 10) > 3) return 'unexpected pin number';

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                that.notified = false;
                if (that._pioPins[pin].hardPWM[0] == Konashi.consts.ENABLE) throw new Error('same'); // 同じ状態にするコマンドは送らない

                if (that._pioPins[pin].config[0] == Konashi.consts.ENABLE){
                    return that._konashi.setGpio(pin, Konashi.consts.DISABLE, 0, 0);
                } else if (that._pioPins[pin].config[0] == 4){
                    return that._konashi.setSpi(Konashi.consts.DISABLE, 0, 0, 0, 0);
                } return;
            })
            .then(() => that._konashi.setHardPwmPin(pin, Konashi.consts.ENABLE))
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    setHardPWM (clk, presc, value){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(value)) return 'Not a Number';
        if (value < 0) value = 0;
        if (value > 65535) value = 65535;

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                that.notified = false;
                if (parseInt(`${clk}${presc}`, 10) == that.clkConfig[0] &&
                    value == that.clkConfig[1]) throw new Error('same');
                // 同じ状態にするコマンドは送らない
                that.clkConfig = [null, null];
                return that._konashi.setHardPWM(clk, presc, value);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    outHardPWM (pin, value, trans){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(trans)) return 'Not a Number';
        if (trans < 0) trans = 0;
        if (trans > 4294967295) trans = 4294967295;

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                that.notified = false;
                if (that._pioPins[pin].config[0] != 2) throw new Error('It\'s not hardPWM pin mode');
                if (value == that._pioPins[pin].hardPWM[1]) throw new Error('Same');

                that._pioPins[pin].hardPWM[1] = -1;
                return that._konashi.outHardPWM(pin, value, trans);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    readHardPWM (pin, type) {
        if (pin < 0 || pin > 3) return 'unexpected pin number'; // gpioPinの範囲内

        if (type == 0) return this._pioPins[pin].hardPWM[1];
        if (type == 1) return this._pioPins[pin].hardPWM[2];
    }

    setAio (pin, mode) {
        if (!this._konashi) return; // konashiを読み込めているか確認

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                if (mode == that._aioPins[pin].config - 2) throw new Error('Same');
                that._aioPins[pin].config = -1;
                return that._konashi.setAio(pin, Konashi.consts.ENABLE, mode);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    setAdcPeri (value) {
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(value)) return 'Not a Number';
        if (value < 0) value = 0;
        if (value > 255) value = 255;

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                if (value == that.anaConfig[0]) throw new Error('Same');
                that.anaConfig[0] = -1;
                return that._konashi.setAdcPeri(value);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * Analog config command
     * @param {number} type -
     * @param {number} value -
     * @returns {string} - ふきだしの中身
     */
    setAnaConf (type, value) {
        if (!this._konashi) return; // konashiを読み込めているか確認

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                if (value == that.anaConfig[type]) throw new Error('Same');
                that.anaConfig[type] = -1;
                return that._konashi.setAnaConf(type, value);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * Analog control command
     * @param {number} pin - ピン番号
     * @param {number} ctrl - Control Value
     * @param {number} trans - 遷移時間
     * @returns {string} - ふきだしの中身
     */
    outAio (pin, ctrl, trans) {
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (pin == 0){
            if (isNaN(ctrl) || isNaN(trans)) return 'Not a Number';
            if (ctrl < 0) ctrl = 0; if (ctrl > 31) ctrl = 31;
            if (trans < 0) trans = 0; if (trans > 4294967295) trans = 4294967295;
        } else {
            if (isNaN(ctrl) || isNaN(trans)) return 'Not a Number';
            if (ctrl < 0) ctrl = 0; if (ctrl > 4095) ctrl = 4095;
            if (trans < 0) trans = 0; if (trans > 4294967295) trans = 4294967295;
        }

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                if (that._aioPins[pin].config !=
                    Konashi.consts.NOTIFY + Konashi.consts.OUTPUT) throw new Error('It\'s not out mode');
                that._aioPins[pin].output[1] = -1;
                return that._konashi.outAnalog(pin, ctrl, trans);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * 指定されたピンの出力，入力状態を返す
     * @param {number} pin - ピン番号
     * @param {number} io - 0:input 1:output
     * @returns {number} this._aioPins[pin].input[1]/output[1]
     */
    readAio (pin, io) {
        if (pin < 0 || pin > 2) return 'unexpected pin number'; // aioPinの範囲内

        if (io == 0) return this._aioPins[pin].input[1];
        if (io == 1) return this._aioPins[pin].output[1];
        return;
    }

    /**
     * I2C config command
     * @param {number} mode - 0:Normal 1:Fast
     * @returns {string} - ふきだしの中身
     */
    setI2c (mode){
        if (!this._konashi) return; // konashiを読み込めているか確認

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.NORMAL * that._isSending)
            .then(() => {
                that.notified = false;
                if (mode == that.i2c[0] - 2) throw new Error('Same');
                
                if (that._pioPins[6].config[0] == Konashi.consts.ENABLE){
                    return that._konashi.setGpio(6, Konashi.consts.DISABLE, 0, 0);
                } else if (that._pioPins[6].config[0] == 2){
                    return that._konashi.setSoftPWM(2, Konashi.consts.DISABLE, 0);
                } return;
            })
            .then(() => {
                if (that._pioPins[7].config[0] == Konashi.consts.ENABLE){
                    return that._konashi.setGpio(7, Konashi.consts.DISABLE, 0, 0);
                } else if (that._pioPins[7].config[0] == 2){
                    return that._konashi.setSoftPWM(3, Konashi.consts.DISABLE, 0);
                } return;
            })
            .then(() => {
                that.i2c[0] = -1;
                return that._konashi.setI2c(Konashi.consts.ENABLE, mode);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * I2C transfer command
     * @param {number} op - 0:Write 1:Read 2:Both
     * @param {number} rlen - read length
     * @param {number} addr - Slave Address
     * @param {number} value - Write data
     * @returns {string} - ふきだしの中身
     */
    useI2c (op, rlen, addr, value){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(rlen) || isNaN(addr)) return 'Not a Number';
        if (rlen < 0) rlen = 0; if (rlen > 126) rlen = 126;
        if (addr < 0) addr = 0; if (addr > 0x7f) addr = 0x7f;

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (that.i2c[0] < 2) throw new Error('Not I2C mode');
                return this._konashi.useI2c(op, rlen, addr, value);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * UART config command
     * @param {number} parity - 0:None 1:Odd 2:Even
     * @param {number} stopbit - 0:0.5 1:1 2:1.5 3:2
     * @param {number} baud - ボーレート
     * @returns {string} - ふきだしの中身
     */
    setUart (parity, stopbit, baud){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(baud)) return 'Not a Number';
        if (baud < 0) baud = 0;
        if (baud > 4294967295) baud = 4294967295;

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (JSON.stringify([that.uart[0], that.uart[1], that.uart[2]]) ==
                    JSON.stringify([parity, stopbit, baud])) throw new Error('Same');
                that.uart = [];
                return that._konashi.setUart(Konashi.consts.ENABLE, parity, stopbit, baud);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * UART send command
     * @param {string} str - エンコードする文字列
     * @returns {string} - ふきだしの中身
     */
    sendUart (str){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (str.length > 128) return 'over flow';

        let value = '';
        for (let i = 0; i < str.length; i++){
            try {
                value += (`0000${str.charCodeAt(i).toString(16)}`).slice(-4);
            } catch (e){
                break;
            }
        }

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (that.uart[2] === null) throw new Error('baudrate is null');
                that.uart[3] = 0;
                return that._konashi.sendUart(value);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * SPI config command
     * @param {number} endian - 0:little endian 1:big endian
     * @param {number} mode - SPIモード
     * @param {number} speed - 通信スピード
     * @returns {Promise|string} コマンド結果のPromise、またはエラーメッセージ文字列
     */
    setSpi (endian, mode, speed){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (isNaN(speed)) return 'Not a Number';
        if (speed < 0) speed = 0;
        if (speed > 4294967295) speed = 4294967295;

        let pola = 0; let phas = 0;
        if (mode == 2 || mode == 3){
            pola = 1;
        }
        if (mode == 1 || mode == 3){
            phas = 1;
        }

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (JSON.stringify(that.spiConf) == JSON.stringify([endian, pola, phas, speed]) &&
                    that._pioPins[2].config[0] == 4 && that._pioPins[3].config[0] == 4 &&
                    that._pioPins[4].config[0] == 4 && that._pioPins[5].config[0] == 4) throw new Error('Same');
                that.spiConf = [];
                return that._konashi.setSpi(Konashi.consts.ENABLE, endian, pola, phas, speed);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * SPI transfer command
     * @param {Array} value - 送信データ(2桁ずつの16進数を10進数にした配列)
     * @returns {string} - ふきだしの中身
     */
    writeSpi (value){
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (value.length > 128) return 'over flow';

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                if (that.spiConf[3] === null) throw new Error('bit rate is null');
                return that._konashi.writeSpi(value);
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }

    /**
     * AccelGyro
     * @param {number} ag - 0:加速度 1:ジャイロ
     * @param {number} xyz - 0:x方向 1:y方向 2:z方向
     * @returns {number} - 保存されている返り値
     */
    getAG (ag, xyz){
        if (!this._konashi) return; // konashiを読み込めているか確認

        const section = (ag * 3) + xyz;
        return this._ag[section];
    }

    /**
     * LEDで光らせたい色を指定する．
     * @param {number} color - 0:R 1:G 2:B 3:α
     * @param {number} value - 光の強さ
     * @returns {string} - ふきだしの中身
     */
    setColorLED (color, value) { // 登録してある送信用データを更新するだけで、通信はしない
        if (color > 4 || color < 0) return 'Not a Number'; // 色の範囲内
        if (value > 255) value = 255;
        if (value < 0) value = 0;
        if (isNaN(value)) return 'Not a Number (value)';
        this._colors[color] = parseInt(value, 10);// [赤,緑,青,α]で登録される
    }

    /**
     * RGB Set
     * setColorLEDで設定するthis.colorsに従ってLEDの色を変える．
     * @param {number} trans - 遷移時間
     * @returns {string} - ふきだしの中身
     */
    outColorLED (trans) {
        if (!this._konashi) return; // konashiを読み込めているか確認
        if (trans > 65535) trans = 65535;
        if (trans < 0) trans = 0;

        const colors = [this._colors[0], this._colors[1], this._colors[2], this._colors[3]];

        const that = this;
        that._isSending++;
        return that.wait(BLE_DELAY.LONG * that._isSending)
            .then(() => {
                this.notified = false;
                this._colors = [];
                return that._konashi.outColorLED(colors, trans); // 送信
            })
            .then(() => {
                that._isSending--;
                return 'done';
            })
            .catch(e => {
                that._isSending--;
                that.notified = true;
                return e;
            });
    }


    /**
     * reset hard's all value
     *
     * @param {Array} v this._pioPins[pin.number].config[0]
     * @returns {Promise} Promise resolved when all reset commands have been sent
     */
    _reset (v) {
        if (!this._konashi) return; // konashiを読み込めているか確認

        const that = this;

        let promises = Promise.resolve(true);

        for (let i = 0; i < 4; i++){
            if (v[i] == 2){
                promises = promises.then(() => that._konashi
                    .outHardPWM(i, Konashi.consts.DISABLE, Konashi.consts.DISABLE)
                    .catch(e => console.log(e)));
                promises = promises.then(() => that._konashi
                    .setHardPwmPin(i, Konashi.consts.DISABLE)
                    .catch(e => console.log(e)));
            }
            if (v[i + 4] == 2){
                promises = promises.then(() => that._konashi
                    .outSoftPWM(i, Konashi.consts.DISABLE, Konashi.consts.DISABLE)
                    .catch(e => console.log(e)));
                promises = promises.then(() => that._konashi
                    .setSoftPWM(i, Konashi.consts.DISABLE, 0)
                    .catch(e => console.log(e)));
            }
        }
        if (v[6] == 3){
            promises = promises.then(() => that._konashi.setI2c(Konashi.consts.DISABLE, 0).catch(e => console.log(e)));
        }
        for (let i = 0; i < 8; i++){
            console.log(v[i]);
            if (v[i] == 1){
                promises = promises.then(() => that._konashi
                    .setGpio(i, Konashi.consts.DISABLE, Konashi.consts.INPUT, Konashi.consts.NO_PULLS)
                    .catch(e => console.log(e)));
            }
        }
        for (let i = 0; i < 3; i++){
            promises = promises.then(() => that._konashi
                .setAio(i, Konashi.consts.DISABLE, Konashi.consts.INPUT)
                .catch(e => console.log(e)));
        }
        promises = promises.then(() => that._konashi
            .setUart(Konashi.consts.DISABLE, 0, 0, 0)
            .catch(e => console.log(e)));
        promises = promises.then(() => that._konashi
            .setSpi(Konashi.consts.DISABLE, 0, 0, 0, 0)
            .catch(e => console.log(e)));
        promises = promises.then(() => that._konashi.outColorLED([0, 0, 0, 0], 0).catch(e => console.log(e)));
        return promises;
    }

    _addevent (){
        return this._konashi.addEvents(this._onNotified); // 送信
    }

    _removeevent (){
        return this._konashi.removeEvents(); // 送信
    }

    /**
     * 引数だけ待った後，notificationが帰ってくるまで待つ．
     * 10ms*100待っても帰ってこなければrejectを返す．
     * @param {number} extra - はじめの待ち時間
     * @returns {Promise} - resolveなら次の工程に進む．
     */
    wait (extra){
        const that = this;
        let spand = 0;
        return new Promise((resolve, reject) => {
            let id;
            const waitFunc = function () {
                spand++;
                if (spand >= 100){
                    return reject(new Error('もう一度お願いします'));
                }
                if (that.notified == true){
                    that.notified = false;
                    return resolve();
                }
                clearTimeout(id);
                id = setTimeout(waitFunc, 10);
            };
            id = setTimeout(waitFunc, extra);
        });
    }
}
/**
 * 上記KokoroProを返します．
 * @module KokoroPro
 */
module.exports = KokoroPro;
